module.exports = __webpack_public_path__ + "img/resume-parser.769e34f8.svg";